// src/components/button/BtnAddUser.tsx

import { PersonAddTwoTone } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'

type BtnAddUserProps = {
  onClick?: () => void
}

export const BtnAddUser = ({ onClick }: BtnAddUserProps) => (
  <Tooltip arrow placement={'top'} title={'Hinzufügen'}>
    <IconButton onClick={onClick} sx={{ bgcolor: '#DDD' }}>
      <PersonAddTwoTone />
    </IconButton>
  </Tooltip>
)
